import {
  Accordion,
  Text,
  createStyles,
} from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { Details } from "./Details";



const useStyles = createStyles(() => ({
  text: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#262930",
  
  },
}));
interface Props {
  service?: any;

}

export const ServiceDetails: React.FC<Props> = ({
  service
}) => {
  const { classes } = useStyles();

  return (
    <>
      <Accordion
        chevron={<IconPlus size="3rem" />}
        styles={{
          chevron: {
            "&[data-rotate]": {
              transform: "rotate(45deg)",
            },
          },
        }}
      >
        <Accordion.Item value={service?.name ? service?.name : "--"}>
          <Accordion.Control
            sx={{
              backgroundColor: "#BEDEF8",
              "&:hover": {
                backgroundColor: "#cde9ff",
                textDecoration: "underline",
              },
            }}
          >
            <Text className={classes.text}>{service?.name}</Text>
          </Accordion.Control>
          <Accordion.Panel pt={16} bg={"#F1F9FF"}>
            <Details service={service} />
          </Accordion.Panel>
        </Accordion.Item>
        {/* ... content */}
      </Accordion>
    </>
  );
};
